import LoginButton from "./button";

const Content = ({ handlelogin, loading }) => {
  return (
    <div className="text-center self-center px-10 mt-8 md:my-auto absolute bottom-24">
      <p className="h-20px-demibold text-white  mb-2">
        زنجیره کاملی از خدمات مالی و سرمایه‌گذاری
      </p>
      <span className="text-gray--12 body-14px-regular">
        سرمایه‌گذاری به روش ساده
      </span>
      <LoginButton handlelogin={handlelogin} loading={loading} />
    </div>
  );
};
export default Content;
